import {
  type FoGesrTableDrawContext,
  computeFoGesrParticipantImageRowHeight,
  drawFoGesrTableImageCell,
  drawFoGesrTextColumn,
  ensureFoGesrTableRowFitsPage,
  tryResolveCellImageDraw,
} from '../infrastructure/foGesrTableDrawingPrimitives.ts';
import { MAX_FIRMA_CELL_MM, MAX_FOTO_CELL_MM } from '../infrastructure/resolveImageForPdf.ts';

export type RedencionTableDrawContext = FoGesrTableDrawContext;

export { drawFoGesrTableTextRow as drawRedencionTextRow } from '../infrastructure/foGesrTableDrawingPrimitives.ts';
/** Draw redencion banner row. */


export function drawRedencionBannerRow(ctx: RedencionTableDrawContext, title: string): void {
  const { doc, y, margin, pageH, w } = ctx;
  const usableW = w.reduce((a, b) => a + b, 0);
  const rowH = 6.2;
  if (y.current + rowH > pageH - margin - 8) {
    ctx.newPage();
  }
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.rect(margin, y.current, usableW, rowH);
  ctx.setBold(8.5);
  doc.text(title, margin + usableW / 2, y.current + 4.1, { align: 'center' });
  y.current += rowH;
  ctx.setNormal(5);
}

/** Participant table row: six text columns + photo + signature (FO-GESR-1775). */
export async function drawRedencionParticipantRow(
  ctx: RedencionTableDrawContext,
  cells: string[],
  registroFotografico: string,
  firma: string,
): Promise<void> {
  const { doc, y, margin, w, lh, pad, setNormal, cellLines } = ctx;
  const fs = 6;
  setNormal(fs);

  const w6 = w[6] ?? 0;
  const w7 = w[7] ?? 0;
  const fotoDraw = await tryResolveCellImageDraw(registroFotografico, w6 - pad * 2, MAX_FOTO_CELL_MM);
  const firmaDraw = await tryResolveCellImageDraw(firma, w7 - pad * 2, MAX_FIRMA_CELL_MM);

  const textColsIdx = [0, 1, 2, 3, 4, 5] as const;
  const rowH = computeFoGesrParticipantImageRowHeight({
    cellLines,
    cells,
    textColIndices: textColsIdx,
    fs,
    lh,
    pad,
    fotoDraw,
    firmaDraw,
  });
  ensureFoGesrTableRowFitsPage(ctx, rowH);

  const yTop = y.current;
  let x = margin;
  for (let i = 0; i < 6; i += 1) {
    x = drawFoGesrTextColumn(ctx, cells, { colIdx: i, x, yTop, rowH, wi: w[i] ?? 0, fs });
  }

  doc.rect(x, yTop, w6, rowH);
  await drawFoGesrTableImageCell(doc, x, yTop, w6, pad, lh, fotoDraw);
  x += w6;

  doc.rect(x, yTop, w7, rowH);
  await drawFoGesrTableImageCell(doc, x, yTop, w7, pad, lh, firmaDraw);

  y.current += rowH;
  setNormal(6);
}
